/*
 * Project: LegalPlace assistant
 * File: src\components\misc\text.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */
// init the react environment
import React, { Component } from 'react';
import { connect } from 'react-redux';

// generate keys functions
import { generateId1 } from '../utils/misc';

// update the redux system
import {
  initOutputVariable, editVariable, initOutputOption, editOption,
} from '../../redux/actions/output';
import { icSetOption, icSetVariable } from '../../redux/actions/input_context';
import LpHelper from './helper';
import LpPopupPreview from '../popup_preview';
import { lpGetVariableById, lpGetOptionById } from '../../logic/re_index';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import LpWarning from './warning';
import lpApp from '../../app/lp_app';

// onfocus and onblur

// inputs: placeholder, id, label, helper (if it exists)
class SingleTextField extends Component {
  constructor(props) {
    super(props);
    // register the variable/option
    // bind the events here
    this.params = {
      ...props,
    };
    this.lpKey = generateId1(4);


    this.onValueChanged = this.onValueChanged.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);

    if (props.isDuplicate) {
      this.params.id = `${this.params.id}_${props.copy}`;
    }
  }


  // TODO: work on dispathcing things upside down, multiple, duplicate ....
  // before putting the shit into the dom
  componentWillMount() {
    // console.time("text_" + this.props.id);
    // TODO: check the duplication in the fucking existant UI component
    if (!this.props.exists) {
      this.props.initializeOutput(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, this.props.lpKey, this.props.ovc, lpApp.indexes.variables.getVariable(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id).value);
    } else {
      this.params.label = lpApp.references.getOption(this.props.id);
    }
    // console.timeEnd("text_" + this.props.id);
  }

  componentDidMount() {
    // In case props value is not equal to state value
    // we update it in state (must be a prefilled value)
    if(this.props.value.length > 0 && this.props.value !== lpGetVariableById(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}`
    : this.props.id).value) {
      this.props.editOutput(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}`
      : this.props.id, this.props.value)
    }
  }

  onValueChanged(val) {
    this.props.editOutput(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.params.id, val);
  }

  onFocus() {
    //this.props.updateContext();
  }

  onBlur() {
    this.props.unUpdateContext;
  }

  render() {
    let variable_ref = lpApp.references.getVariable(this.props.id);

    // Placeholder
    let placeholder = (variable_ref && variable_ref.placeholder) ? variable_ref.placeholder : "";

    return (<div className="form-group" data-type="text-input" data-id={this.props.id} data-is-duplicate={this.props.is_duplicate} data-copy={this.props.copy}>

     <label htmlFor={`text_${this.props.lpKey}`}>
        { this.props.label }
        {' '}
        {'helper' in lpApp.references.getVariable(this.props.id) && lpApp.references.getVariable(this.props.id).helper.length > 0 && <LpHelper text={lpApp.references.getVariable(this.props.id).helper} />}
      </label>
      {(this.props.id in lpApp.references.variables) && lpApp.references.getVariable(this.props.id).warning && <LpWarning text={lpApp.references.getVariable(this.props.id).warning} id={this.props.id} type="v" />}
      <div className="fc-container">
        <input
          type="text"
          name={generateId1(1)}
          placeholder={placeholder}
          id={`text_${this.props.lpKey}`}
          value={this.props.value}
          autoComplete={this.props.autocomplete}
          onChange={evt => this.onValueChanged(evt.target.value)}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          className="form-control"
        />
      </div>

    </div>);
  }
}

const mapStateToProps = (state, ownProps) => {
  // test if exists
  let exists = false;
  let existantKey = '';
  const existantParent = '';
  let value = '';
  const realId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;

  if (ownProps.ovc === 'o') {
    if (typeof lpGetOptionById(realId) !== 'undefined') {
      exists = true;
      existantKey = lpGetOptionById(realId).key;
      ({ value } = lpGetOptionById(realId));
    }
  }
  if (ownProps.ovc === 'v') {
    if (typeof lpGetVariableById(realId) !== 'undefined') {
      exists = true;
      existantKey = lpGetVariableById(realId).key;
      ({ value } = lpGetVariableById(realId));
    }
  }

  /**
   * Prefilling
   */
  if (lpApp.references.variables[ownProps.id].prefillings !== undefined) {
    const { prefillings } = lpApp.references.variables[ownProps.id];
    let executePrefill = (value.length === 0);
    prefillings.forEach((idx) => {
      if (value === idx.text.slice()) executePrefill = true;
    });
    if (prefillings.length !== 0 && executePrefill) {
      for(let i = 0; i < prefillings.length; i++){
        let idx = prefillings[i];
        let text = idx.text.slice();
        let fillForm = false;
        if (idx.compiledConditions.length > 0)
            fillForm = ConditionsEvo.rawCondition(idx.compiledConditions, ownProps.copy != -2 ? ownProps.copy : false)
        else 
            fillForm = true;
        
        if (fillForm) {
          text = text.replace(/\[var:([0-9]+)\]/gi, (a, id) => {
            const variable = lpApp.indexes.variables.getVariable(id);
            const varValue = (variable) ? variable.value.toString() : '';
            return (varValue.trim().length > 0) ? varValue : '________________';
          });
          
          // Looking for old value in prefills
          let foundValueInPrefills = false;
          for(var i = 0; i < prefillings.length; i++){
            if(value == prefillings[i].text){
              foundValueInPrefills = true;
            }
          }

          // Making sure we do not override user input value
          if(foundValueInPrefills === true || value.trim().length === 0){
            value = text;
            break; 
          }
        }
      }
    }
  }
  
  // have the parent
  // if(exists){
  //     if(typeof lpGetFlatById(existant_key) != 'undefined'){
  //         existant_parent = lpGetFlatById(existant_key).parentUi
  //     }
  // }
  let isShown = false;
  if ((state.input_context.variable !== '') && (state.input_context.variable === ownProps.id)) {
    isShown = true;
  }
  const hw = lpApp.indexes.var_to_view.getViewByVar(ownProps.id);
  return {
    had_output: hw ? hw.length > 0 : false,
    sectionId: state.contract.currentSection,
    exists,
    existant_key: existantKey,
    existant_parent: existantParent,
    value,
    show_popup: isShown,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  // this case, parent = key
  initializeOutput: (id, parent, genre, value = '') => {
    if (genre === 'o') dispatch(initOutputOption(id, parent, value));
    else if (genre === 'v') dispatch(initOutputVariable(id, parent, value));
  },
  editOutput: (id, val) => {
    if (ownProps.ovc === 'o') {
      dispatch(editOption(id, val));
    } else {
      dispatch(editVariable(id, val));
    }
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
  updateContext: () => {
    const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
    const pId = ownProps.isDuplicate ? `${ownProps.parent}_${ownProps.copy}` : ownProps.parent;
    if (ownProps.ovc === 'o') dispatch(icSetOption(cId));
    else {
      dispatch(icSetVariable(cId));
      dispatch(icSetOption(pId));
    }
  },
  unUpdateContext: () => {
    if (ownProps.ovc === 'o') dispatch(icSetOption(''));
    else {
      dispatch(icSetVariable(''));
      dispatch(icSetOption(''));
    }
  },
});

const LpText = connect(mapStateToProps, mapDispatchToProps)(SingleTextField);

export default LpText;



// WEBPACK FOOTER //
// ./src/components/misc/text.js